import React from "react";
import PropTypes from "prop-types";
import { isEmpty } from "lodash";
import { displayVarsomePremiumMessage } from "../../../../../../common/helpers/helpers";
import { HIGHLIGHT_DATABASES } from "../../helpers/constants";
import EngineCell from "./rowCells/EngineCell";
import ScoresCell from "./rowCells/ScoresCell";
import IndicativePredictionCell from "./rowCells/IndicativePredictionCell";
import CustomScoreCell from "./rowCells/CustomScoreCell";
import CalibratedPredictionCell from "./rowCells/CalbratedPredictionCell";

const InSilicoPredictionsScoresRow = ({
  database,
  isUserPremium,
  showRawData,
}) => {
  if (
    !database ||
    !Object.keys(database).length ||
    (!database.scores.length && isUserPremium) ||
    (!database.scores.length && !database.isPremium) ||
    (!database.scores.length && !isUserPremium && __IS_COMPONENTS_PORTAL__)
  )
    return null;

  const hightlightClass = HIGHLIGHT_DATABASES.includes(database.name)
    ? "highlight"
    : "";

  const customStyle = isEmpty(database?.customKeys)
    ? {}
    : { display: "flex", height: "16.8px" };

  if (!__IS_COMPONENTS_PORTAL__ && database.isPremium && !isUserPremium) {
    return (
      <tr
        className="dbnsfp-row"
        data-testid="insilico_predictions_row_premium_message"
      >
        <td>
          <EngineCell database={database} customStyle={customStyle} />
        </td>
        {!isUserPremium && database.isPremium && (
          <td colSpan={showRawData ? "7" : " 4"}>
            {displayVarsomePremiumMessage()}
          </td>
        )}
      </tr>
    );
  }

  return (
    <tr
      className={`${hightlightClass} dbnsfp-row`}
      data-testid="insilico_prediction_row"
    >
      <td>
        <EngineCell database={database} customStyle={customStyle} />
      </td>
      <td data-testid="calibrated_prediction_cell">
        <CalibratedPredictionCell
          database={database}
          customStyle={customStyle}
        />
      </td>
      <td data-testid="scores_cell">
        <ScoresCell database={database} customStyle={customStyle} />
      </td>
      {showRawData && (
        <>
          <td data-testid="indicative_prediction_cell">
            <IndicativePredictionCell
              database={database}
              customStyle={customStyle}
            />
          </td>
          {database?.rankScores?.length ? (
            <td data-testid="rankscore_cell">
              <CustomScoreCell
                values={database?.rankScores}
                title={database?.customKeys?.rankscore}
                name={database?.name}
                displayExplanation={true}
                testId="rankscore"
              />
            </td>
          ) : (
            <td />
          )}
          {!!database?.omegaScores?.length && (
            <td data-testid="omega_score_cell">
              <CustomScoreCell
                values={database?.omegaScores}
                title="Omega"
                testId="omega_score"
              />
            </td>
          )}
          {!!database?.phredCodingScores?.length && (
            <td data-testid="phred_score_cell">
              <CustomScoreCell
                values={database?.phredCodingScores}
                title="PC phred coding score"
                testId="phred_score"
              />
            </td>
          )}
          {!database?.omegaScores?.length &&
            !database?.phredCodingScores?.length && <td />}
        </>
      )}
      <td>
        <div style={customStyle} />
        {database.version}
        {database.customSubText}
      </td>
    </tr>
  );
};

InSilicoPredictionsScoresRow.propTypes = {
  database: PropTypes.shape({
    strength: PropTypes.string,
    color: PropTypes.string,
    name: PropTypes.string,
    url: PropTypes.string,
    anchorText: PropTypes.string,
    calibratedPredictionPerScore: PropTypes.arrayOf(PropTypes.string),
    colorPerScore: PropTypes.arrayOf(PropTypes.string),
    scores: PropTypes.arrayOf(
      PropTypes.oneOfType([PropTypes.number, PropTypes.string])
    ),
    customSubText: PropTypes.element,
    customKeys: PropTypes.shape({
      score: PropTypes.string,
      rankscore: PropTypes.string,
    }),
    isPremium: PropTypes.bool,
    version: PropTypes.shape({}),
    pathogenicity: PropTypes.string,
    rankScores: PropTypes.arrayOf(PropTypes.number),
    omegaScores: PropTypes.arrayOf(PropTypes.number),
    phredCodingScores: PropTypes.arrayOf(PropTypes.number),
    indicativePrediction: PropTypes.arrayOf(PropTypes.string),
  }).isRequired,
  isUserPremium: PropTypes.bool.isRequired,
  showRawData: PropTypes.bool.isRequired,
};

InSilicoPredictionsScoresRow.defaultProps = {};

export default InSilicoPredictionsScoresRow;
